import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { styleButtonSquare } from '@/ui/segments/landing/styles';
import { classNames } from '@/util/utils';
import type React from 'react';
import styles from './contact-us.module.css';
interface ContactUsProps {
  className?: string;
  children: React.ReactNode;
  email?: string;
}
export default function ContactUs(t0) {
  const $ = _c(8);
  const {
    className,
    children,
    email: t1
  } = t0;
  const email = t1 === undefined ? "support@openbraininstitute.org" : t1;
  let t2;
  if ($[0] !== className) {
    t2 = classNames(className, styles.contactUs);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `mailto:${email}`;
  let t4;
  if ($[2] !== children || $[3] !== t3) {
    t4 = <Link className={styleButtonSquare} href={t3}>{children}</Link>;
    $[2] = children;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t4) {
    t5 = <div className={t2}>{t4}</div>;
    $[5] = t2;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}